import React from 'react'

import { Paper, withStyles, Typography } from '@material-ui/core'
import { FilterNone } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'

const noDataDisplay = props => {
  return (
    <StyledPaper>
      <FilterNone color={'disabled'} style={{ fontSize: '3rem' }} />
      <Typography variant={'h5'} color={'textSecondary'}>
        {props.translate('noDataDisplay')}
      </Typography>
    </StyledPaper>
  )
}

const StyledPaper = withStyles(theme => {
  return {
    root: {
      height: 400,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    }
  }
})(Paper)

export default withTranslate(noDataDisplay)
